import { ApprovalTabSpec } from "./approvalTabBase";
import { timesheetTabSpec } from "./tabs/TimesheetApproval/TimesheetApprovalTab";
import { stageTransitionTabSpec } from "./tabs/StageTransitionApproval/StageTransitionApprovalTab";

export const approvalTabSpecs: ApprovalTabSpec[] = [timesheetTabSpec, stageTransitionTabSpec];
